import React, {useState} from 'react';
import {Container, FormControl, InputGroup, Form} from "react-bootstrap";
import {CustomButton, TabBar, TabItem} from "../components";
import NextIcon from "../assets/next-icon";
import {ActiveCircleIcon, CheckWhiteIcon, CircleCheckICon, EmailIcon} from "../assets";
import CircleEmptyIcon from "../assets/circle-empty-icon";
import {PATH_APP, PATH_AUTH} from "../routes/paths";
import JalaliDatePicker from "../components/datepicker";
import {useNavigate} from "react-router";
import {toast} from "react-toastify";
import {useForm} from "react-hook-form";
import {FormProvider} from "../components/hook-form";
import * as yup from "yup";
import {yupResolver} from "@hookform/resolvers/yup";
import {Link} from "react-router-dom";
import BackIcon from "../assets/back-icon";
import {Picker} from "react-mobile-style-picker";

function Verify() {
    const [value, setValue] = useState(new Date());
    const [maritalStatus, setMaritalStatus] = useState("married");
    let navigate = useNavigate();
    const validationSchema = yup.object({
        full_name: yup.string().required("نام و نام خانواد" +
            "ی الزامی است"),
        job: yup.string().required("شغل الزامی است"),
        state: yup.string().required("استان الزامی است"),
        city: yup.string().required("شهر الزامی است"),
    });

    const resolver = yupResolver(validationSchema);
    const methods = useForm({resolver});

    const {
        register,
        handleSubmit,
        formState: {errors},
    } = methods;

    const onSubmit = async (data) => {

        try {
            localStorage.setItem('birth_date', value.toLocaleDateString("fa-ir", {
                year: "numeric",
                month: "2-digit",
                day: "2-digit"
            }))
            localStorage.setItem('personal_info', JSON.stringify(data))
            localStorage.setItem('marital_status', maritalStatus)
            navigate(PATH_APP.userInformation)
        } catch (error) {

        }

    };
    return (
        <div id="information-page">
            <>
                <header className="fixed-top"
                        style={{backdropFilter: "blur(6px)", backgroundColor: "rgb(255 255 255 / 50%)"}}>
                    <h6 className="text-center p-4 mb-0">
                        <Link to={PATH_APP.confirm} className="float-end">
                            <BackIcon/>
                        </Link>
                        اطلاعات شخصی</h6>
                </header>
                <header className="d-flex justify-content-between align-items-center">
                    <Container style={{paddingRight: "0", paddingLeft: "0", marginTop: "88px"}}>
                        <TabBar>
                            <div>
                                <TabItem href="#"
                                         icon={<ActiveCircleIcon fill1="#21242F" fill2="#37C26F" stroke="#37C26F"/>}
                                         title="اطلاعات شخصی"/>
                            </div>
                            <div>
                                <div style={{borderTop: "3px dotted #434857", width: "15px"}}/>
                            </div>
                            <div>
                                <TabItem href="#"
                                         icon={<CircleEmptyIcon fill="#21242F" stroke="#525767"/>}
                                         title="اطلاعات بدن"/>
                            </div>
                            <div>
                                <div style={{borderTop: "3px dotted #434857", width: "15px"}}/>
                            </div>
                            <div>
                                <TabItem href="#"
                                         icon={<CircleEmptyIcon fill="#21242F" stroke="#525767"/>} title="نوع برنامه"/>
                            </div>
                            <div>
                                <div style={{borderTop: "3px dotted #434857", width: "15px"}}/>
                            </div>
                            <div>
                                <TabItem href="#"
                                         icon={<CircleEmptyIcon fill="#21242F" stroke="#525767"/>}
                                         title="سابقه بیماری"/>
                            </div>
                        </TabBar>
                    </Container>
                </header>
                <Container style={{marginTop: "30px", marginBottom: "100px"}}>
                    <FormProvider methods={methods} onSubmit={handleSubmit(onSubmit)}>
                        <div className="mt-5">
                            <div className="custom-input ">
                                <label className="fw-bold">نام و نام خانوادگی</label>

                                <InputGroup>

                                    <FormControl  {...register('full_name')}
                                                  placeholder="نام و نام خانوادگی ..." size="lg"
                                                  type="text"
                                    />

                                </InputGroup>
                                {
                                    <p className="text-danger">
                                        {errors?.full_name?.message}
                                    </p>
                                }
                            </div>
                            <div className="custom-input ">
                                <label className="fw-bold">شغل</label>

                                <InputGroup>

                                    <FormControl  {...register('job')}
                                                  placeholder="شغل ..." size="lg"
                                                  type="text"
                                    />

                                </InputGroup>
                                {
                                    <p className="text-danger">
                                        {errors?.job?.message}
                                    </p>
                                }
                            </div>
                            <div className="custom-input ">
                                <label className="fw-bold">استان</label>
                                <InputGroup>

                                    <FormControl  {...register('state')}
                                                  placeholder="استان ..." size="lg"
                                                  type="text"
                                    />

                                </InputGroup>
                                {
                                    <p className="text-danger">
                                        {errors?.state?.message}
                                    </p>
                                }
                            </div>
                            <div className="custom-input ">
                                <label className="fw-bold">شهرستان</label>
                                <InputGroup>

                                    <FormControl   {...register('city')}
                                                   placeholder="شهرستان ..." size="lg"
                                                   type="text"
                                    />

                                </InputGroup>
                                {
                                    <p className="text-danger">
                                        {errors?.city?.message}
                                    </p>
                                }
                            </div>
                            <label className="fw-bold">تحصیلات</label>
                            <InputGroup>
                                <Form.Select {...register('study')} aria-label="تحصیلات">
                                    <option value="1">زیر دیپلم</option>
                                    <option value="2">دیپلم</option>
                                    <option value="3">لیسانس</option>
                                    <option value="4">فوق لیسانس</option>
                                    <option value="5">دکتری</option>
                                </Form.Select>
                            </InputGroup>

                            <div className="custom-input mt-2" id="datepicker">
                                <label className="fw-bold">تاریخ تولد</label>
                                <JalaliDatePicker value={value} onChange={(newValue) => {
                                    setValue(newValue);
                                }}/>

                            </div>
                            <div className="swipe-picker gender-picker mt-3 d-flex align-items-center bg-white"
                                 dir="ltr">
                                <Picker mode="horizontal" smooth={true} value={maritalStatus} scrollSelect={true}
                                        dragSelect={true}
                                        size={2} onChange={(data) => {
                                    setMaritalStatus(data)
                                }}
                                        clickSelect={true}>
                                    <Picker.Item value="married">متاهل</Picker.Item>
                                    <Picker.Item value="single">مجرد</Picker.Item>


                                </Picker>
                                <span className="mx-3">وضعیت تاهل</span>

                            </div>
                            <div className="user-information-footer">
                                <hr/>

                                <Form.Check
                                    type="switch" {...register('lent')}
                                    className="custom-switch"
                                    label="طی سال روزه میگیرم."
                                />
                                <hr/>

                            </div>
                        </div>
                        <footer className="fixed-bottom"
                                style={{backdropFilter: "blur(6px)", backgroundColor: "rgb(255 255 255 / 50%)"}}>
                            <Container>
                                <CustomButton >
                                    <NextIcon/>
                                    <span>   مرحله بعدی</span>
                                </CustomButton>
                            </Container>
                        </footer>
                    </FormProvider>
                </Container>
            </>
        </div>
    );
}

export default Verify;
